import React from 'react';

import { isDefined } from './is';
import { isEmpty } from './isEmpty';

export const getAreChildrenEmpty = (children: React.ReactNode): boolean => {
  if (!isDefined(children)) {
    return true;
  }

  if (typeof children === 'string' && !isEmpty(children)) {
    return false;
  }

  if (typeof children === 'number') {
    return false;
  }

  return React.Children.toArray(children).every(child => !React.isValidElement(child));
};
